<app-comfort-package #comfortPackage (confirm)="confirmSeats.emit($event)"></app-comfort-package>
